import { Material } from '../commons'

export class MyProfilePutRequest {
  material: Material

  constructor(m: Material) { this.material = m }
}
